import { Component, Input, forwardRef, ViewChild, OnInit, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient } from '@delon/theme';

import { SelectInstantBaseComponent } from '../selectInstant-base';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';

@Component({
  selector: 'app-project-ob-select',
  templateUrl: './project-ob-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProjectOBSelectComponent),
      multi: true
    }
  ]
})
export class ProjectOBSelectComponent
  extends SelectInstantBaseComponent
  implements OnInit
{
  @Input() childOnly = true;

  NotShowInReport: boolean = false;
  isProjectRestricted: boolean = false;

  constructor(
    http: _HttpClient,
    router: Router,
    cdr: ChangeDetectorRef,
    private resueTabService: ReuseTabService,
    private userDefaultService: UserDefaultService
  ) {
    super(http, cdr, router);
  }

  ngOnInit(): void {
    //this.hasProj()
    this.checkAddNewOptionInReportAccess();
    this.userDefaultService.isProjectRestricted().subscribe(isRestricted => {
      this.isProjectRestricted = isRestricted;
      this.cdr.markForCheck();
    });
  }

  getUrl(searchValue: string): string {
    let filter = `isActive eq true`;

    if (this.childOnly) {
      filter = `(${filter}) and hasChildren eq false`;
    }
    if (searchValue && typeof searchValue === 'string') {
      const searchStr = this.odata.getSearchFilterString(searchValue, [
        'code',
        'name'
      ]);

      filter = `(${filter}) AND (${searchStr})`;
    }

    // When restriction is enabled, the server-side Lookup endpoint automatically filters
    // by user default settings, so we use the same endpoint
    var list = `api/projects/lookup?$top=50&$skip=0&$orderby=code asc&$filter=${filter}`;
    return list;
  }

  // set the location want to navigate
  jump(): string {
    return '/company/project';
  }

  // set the param
  queryParam(): String {
    return 'ProjectCode';
  }

  getProjectLabel(project: any): string {
    if (!project) return '';

    const code = project.code ?? project;
    const name = project.name ?? '';

    return name ? `${code} : ${name}` : `${code}`;
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.resueTabService.curUrl.toLowerCase();

    if (curUrl.includes('report')) {
      this.NotShowInReport = true;
    } else {
      this.NotShowInReport = false;
    }

    return this.NotShowInReport;
  }
}
